import { Box, styled } from "@mui/material";

export const StyledAdmin = styled(Box)(({ theme }) => ({
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  ".pageButtons": {
    display: "flex",
    gap: "1rem",
    paddingBlock: "2rem",
    ".pageButton": {
      padding: "1rem 3rem",
      borderRadius: "25px",
      border: `2px solid ${theme.color.main}`,
      background: theme.color.main,
      color: theme.color.background,
      "&.Mui-selected": {
        background: theme.color.contrastColor,
        borderColor: theme.color.contrastColor,
        color: theme.color.background,
      },
      "&.Mui-selected:hover": {
        background: theme.color.contrastColor,
      },
    },
  },
}));
